import { FlexibleDatesProvider } from './FlexibleDatesProvider';

export default FlexibleDatesProvider;
